import React from "react";
import { Grid } from "@material-ui/core";
import { ButtonText } from "@loanbossinc/component-library";
import "./styles.css";

const Accordian = ({ name, showDownload, children }) => (
  <div className="supervised-accordian-container">
    <Grid container className="supervised-accordian-header-wrapper">
      <Grid item xs={6}>{name}</Grid>
      <Grid item xs={6}>
        {showDownload &&
          <div className="supervised-accordian-download-button-wrapper">
            <ButtonText
              onClick={() => { }}
              iconName="get_app"
              label="Download PDF"
              reverse={false}
            />
          </div>}
      </Grid>
    </Grid>
    <div className="supervised-accordian-body-wrapper">{children}</div>
  </div>
);

export default Accordian;
